import { render, staticRenderFns } from "./v-embed.vue?vue&type=template&id=5f04bfe8&scoped=true&"
import script from "./v-embed.vue?vue&type=script&lang=js&"
export * from "./v-embed.vue?vue&type=script&lang=js&"
import style0 from "./v-embed.vue?vue&type=style&index=0&id=5f04bfe8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f04bfe8",
  null
  
)

export default component.exports